import { Contact, QuestionsAndAnswers } from "../types/HelpAndSupportDataTypes";
import helpandSupportIcons from "../assets/helpandSupportIcons/helpandSupportIcons.svg";
import orderQuantity from "../assets/helpandSupportIcons/orderQuantity.svg";
import deliveryTimeline from "../assets/helpandSupportIcons/deliveryTimeline.svg";
import deliveryBus from "../assets/helpandSupportIcons/delieveryBus.svg";
import timeLine from "../assets/helpandSupportIcons/timeLine.svg";
import orderReturn from "../assets/helpandSupportIcons/orderReturn.svg";
import wallet from "../assets/helpandSupportIcons/wallet.svg";
import sealed from "../assets/helpandSupportIcons/sealed.svg";

export const contactData: Contact[] = [
  {
    title: "CALL US AT",
    name: "Jane Doe",
    address: "4140 Parker Rd. Whitefield, Bangalore 560067",
    email: "support@maltora.app",
    phone: "+91-9036025879",
  },
];

export const FAQSData: QuestionsAndAnswers[] = [
  {
    image: helpandSupportIcons,
    question: "How do I place an order?",
    answer:
      "Orders can be placed through our online platform. Simply browse the available products, choose the quantity you need, select your preferred delivery details, and complete the checkout process.",
  },
  {
    image: orderQuantity,
    question: "What is the minimum order quantity?",
    answer:
      "There is no fixed minimum order quantity. You can place an order based on your business requirements and operational needs.",
  },
  {
    image: deliveryTimeline,
    question: "What is the keg delivery timeline?",
    answer:
      "Delivery timelines may vary depending on order size, product availability, and delivery location. Estimated timelines will be shared once the order is confirmed.",
  },
  {
    image: deliveryBus,
    question: "Do you charge extra for delivery?",
    answer:
      "Delivery charges may vary based on the location, order size, and service requirements. Any applicable charges will be clearly shown during the order process.",
  },
  {
    image: timeLine,
    question: "How far in advance should I place my order?",
    answer:
      "We recommend placing your order in advance to ensure smooth processing and timely delivery. For larger orders or special requirements, earlier scheduling is advised.",
  },
  {
    image: orderReturn,
    question: "How do I return the empty kegs?",
    answer:
      "Empty kegs can be returned during the next scheduled delivery or pickup cycle. For urgent returns, you can contact our support team to arrange a separate collection.",
  },
  {
    image: wallet,
    question: "How do I make the payment for the kegs order?",
    answer:
      "Payments can be completed securely through the platform during checkout. Multiple payment options may be available depending on your location and account setup.",
  },
];

export const KeySpecifications: QuestionsAndAnswers[] = [
  {
    image: wallet,
    question: "What size kegs do you offer?",
    answer:
      "Available keg sizes may vary by product and business requirement. Please refer to the product details page or contact support for the latest size options.",
  },
  {
    image: sealed,
    question: "What's the shelf life and how to store the kegs?",
    answer:
      "Shelf life depends on the product type, storage conditions, and whether the keg has been opened or connected. For best results, always store and handle products according to the recommended guidelines.",
  },
];
